// @ts-strict-ignore
import { WagoApiClient } from '@shared/service/wago-api.client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { FriendListEntryVO } from '../friend-list-entry.vo';
import { FriendInfoVO } from '../friend-info.vo';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FriendListService {
  constructor(private modelConversionService: ModelConversionService, private wagoApiClient: WagoApiClient) {}

  public getFriendListByUserId(): Observable<FriendListEntryVO[]> {
    return this.wagoApiClient
      .get('friend-list/search/user')
      .pipe(map((response) => this.modelConversionService.convertFriendListEntryVOs(response)));
  }

  public findUsersAsFriendsByUsername(username: string): Observable<FriendInfoVO[]> {
    return this.wagoApiClient
      .get( `friend-list/info/search/username/${encodeURIComponent(username)}`, null, {
        isErrorHandlingRequired: false,
      })
      .pipe(map((response) => this.modelConversionService.convertFriendInfoVOs(response)));
  }

  public addUserToFriendList(friendListEntry: FriendListEntryVO): Observable<FriendListEntryVO> {
    let httpParams: HttpParams = new HttpParams();
    httpParams = httpParams.append('newFriendUserName', friendListEntry.friendInfo.username);
    const requestOptions = {
      params: httpParams,
    };
    return this.wagoApiClient
      .post('friend-list/user', null, requestOptions)
      .pipe(map((response) => this.modelConversionService.convertFriendListEntryVO(response)));
  }

  public removeUserFromFriendList(friendListEntry: FriendListEntryVO): Observable<boolean> {
    let httpParams: HttpParams = new HttpParams();
    httpParams = httpParams.append('friendUserName', friendListEntry.friendInfo.username);
    const requestOptions = {
      params: httpParams,
    };
    return this.wagoApiClient.delete('friend-list/user', requestOptions);
  }
}
